import { Flex, HStack, Icon, Radio, RadioGroup, Text, VStack } from '@chakra-ui/react';
import { ReactComponent as EyeIcon } from 'assets/icons/eye_icon.svg';
import { ReactComponent as PenIcon } from 'assets/icons/pen_icon.svg';
import { useTranslation } from 'react-i18next';

interface ShareProjectLinkProps {
  disabled: boolean;
  value: string;
  setValue: (value: string) => void;
}

export const ShareProjectLink = ({ disabled = true, value, setValue }: ShareProjectLinkProps) => {
  const { t } = useTranslation('common_navbar');

  return (
    <Flex flexDir='column' gap={2}>
      <Text fontSize='sm' fontWeight={'semibold'} color={'font.500'} lineHeight='1.5'>
        {t('project-link.title')}
      </Text>
      <RadioGroup onChange={setValue} value={value}>
        <VStack align='start' gap={1}>
          <Radio value='1' isDisabled={disabled} gap={2} _disabled={{ color: 'white' }}>
            <HStack gap={2} align='center'>
              <Flex
                p={2}
                bg={'gray.50'}
                justifyContent={'center'}
                alignItems={'center'}
                borderRadius={'4px'}
                width={'36px'}
                height={'36px'}
              >
                <Icon as={PenIcon} height={6} width={6} color={'font.500'} />
              </Flex>
              <VStack align='start' spacing={0}>
                <Text fontWeight={'semibold'} fontSize='sm' color={'font.500'}>
                  {t('project-link.edit')}
                </Text>
                <Text fontSize='xs' color={'font.300'}>
                  {t('project-link.member-edit')}
                </Text>
              </VStack>
            </HStack>
          </Radio>
          <Radio value='2' gap={2}>
            <HStack gap={2} align='center'>
              <Flex
                p={2}
                bg={'gray.50'}
                justifyContent={'center'}
                alignItems={'center'}
                borderRadius={'4px'}
                width={'36px'}
                height={'36px'}
              >
                <Icon as={EyeIcon} height={6} width={6} color={'font.500'} />
              </Flex>
              <VStack align='start' spacing={0}>
                <Text fontWeight={'semibold'} fontSize='sm' color={'font.500'}>
                  {t('project-link.view')}
                </Text>
                <Text fontSize='xs' color={'font.300'}>
                  {t('project-link.public-link')}
                </Text>
              </VStack>
            </HStack>
          </Radio>
        </VStack>
      </RadioGroup>
    </Flex>
  );
};
